export interface Particle { kind: 'spark' | 'dust'; x: number; y: number; vx: number; vy: number; age: number; life: number; size: number }

const GRAVITY = 1100;
export const between = (low: number, high: number) => low + Math.random() * (high - low);

/** Ages, moves and draws every particle onto a cleared canvas, returning those still alive. Sparks cool from white-hot; dust swells and thins. */
export function stepParticles(context: CanvasRenderingContext2D, particles: Particle[], dt: number, width: number, height: number,
  options: { clear?: boolean; hide?: { left: number; top: number; width: number; height: number } } = {}): Particle[] {
  if (options.clear !== false) context.clearRect(0, 0, width, height);
  const alive = particles.filter(particle => (particle.age += dt) < particle.life);
  context.save();
  // Particles that start behind a button stay hidden until they leave its outline.
  if (options.hide) { const { left, top, width: w, height: h } = options.hide; context.beginPath(); context.rect(0, 0, width, height); context.rect(left, top, w, h); context.clip('evenodd'); }
  for (const particle of alive) {
    const t = Math.min(1, Math.max(0, particle.age / particle.life));
    if (particle.kind === 'spark') {
      particle.vy += GRAVITY * dt; particle.x += particle.vx * dt; particle.y += particle.vy * dt;
      // Streaks along the direction of travel that cool from white-hot to dull orange.
      // A dark under-stroke keeps them readable over bright ground, where additive light alone would wash out.
      const tailX = particle.x - particle.vx * .022, tailY = particle.y - particle.vy * .022;
      context.globalCompositeOperation = 'source-over';
      context.strokeStyle = `rgba(30, 18, 8, ${.55 * (1 - t)})`; context.lineWidth = particle.size + 1.8;
      context.beginPath(); context.moveTo(particle.x, particle.y); context.lineTo(tailX, tailY); context.stroke();
      context.globalCompositeOperation = 'lighter';
      context.strokeStyle = `rgba(255, ${Math.round(235 - 150 * t)}, ${Math.round(170 - 150 * t)}, ${1 - t})`; context.lineWidth = particle.size;
      context.beginPath(); context.moveTo(particle.x, particle.y); context.lineTo(tailX, tailY); context.stroke();
    } else {
      particle.x += particle.vx * dt; particle.y += particle.vy * dt; particle.vx *= 1 - dt * .6;
      const radius = particle.size * (.6 + 1.5 * Math.sqrt(t)), alpha = Math.sin(Math.PI * Math.min(1, t * 1.15)) * .4;
      const fill = context.createRadialGradient(particle.x, particle.y, 0, particle.x, particle.y, radius);
      fill.addColorStop(0, `rgba(122, 110, 92, ${alpha})`); fill.addColorStop(1, 'rgba(122, 110, 92, 0)');
      context.globalCompositeOperation = 'source-over'; context.fillStyle = fill;
      context.fillRect(particle.x - radius, particle.y - radius, radius * 2, radius * 2);
    }
  }
  context.restore();
  return alive;
}
